import React from 'react'
import classes from './Latest.module.scss';
import FullWidth from './SubComponents/FullWidth/FullWidth';
import HalfWidth from './SubComponents/HalfWidth/HalfWidth';

function Latest(props) {

    let fullWidth = props.content.FullWidth;
    let halfWidth = props.content.HalfWidth;

    function onLatestClick(event){
		// window.gtag('event', "Latest article selection", {
		// 	'event_category': globalJSON.tracking.ga_category,
		// 	'event_label': "promo article clicked "+ event.url,
		// 	'value':10
        // });
        
        // console.log('selec', event)
	}

    function itemSelectedCallback(selectionData){
        props.onCtaInteraction(selectionData)
    }

    return (
        <section id={"latest"} className={`${classes.latest} `}>
            {(
                fullWidth
                ?
                <div onClick={onLatestClick}>
                    <FullWidth content={fullWidth} windowSize={props.windowSize}  onSelected={(selectionData) => itemSelectedCallback(selectionData)}/>
                </div>
                :
                ""
            )}

            <div className={classes.latest__content_container}  onClick={onLatestClick}>	
                <HalfWidth content={halfWidth} windowSize={props.windowSize}  onSelected={(selectionData) => itemSelectedCallback(selectionData)}/>
            </div>
           
        </section>
    )

}

export default Latest;